import { TContext } from "../types";
import usePageLogUpdatedPriceContext from "./usePageLogUpdatedPriceContext";

const useFilterValue = <Field extends keyof TContext["filter"]["value"]>(
  field: Field
): {
  value: TContext["filter"]["value"][Field];
  update: (newValue: TContext["filter"]["value"][Field]) => void;
  filter: TContext["filter"]["value"];
  filterUpdate: TContext["filter"]["update"];
} => {
  const { filter } = usePageLogUpdatedPriceContext();
  return {
    value: filter.value[field] ?? undefined,
    update: (newValue) => {
      filter.update({ ...filter.value, [field]: newValue });
    },
    filter: filter.value,
    filterUpdate: filter.update,
  };
};

export default useFilterValue;
